/* ===========================================================================
   Global add-to-cart fallback.

   WHY THIS EXISTS
   ajaxCart is initialised in layout/theme.liquid as:

     ajaxCart.init({ formSelector: '.product-form', addToCartSelector: '.AddToCart', ... })

   and cart-drawer.js only binds the submit override when it finds a match:

     if (!settings.disableAjaxCart && $addToCart.length) { formOverride($formContainer); }

   So on any page where no .AddToCart element sits inside a .product-form,
   nothing is intercepted, the form posts natively, and the customer is
   redirected to /cart instead of seeing the drawer. The binding is also done
   once on window load against a fixed jQuery set, so forms injected later
   (quick view, dynamically loaded sections) are never covered.

   This is a delegated listener on document, so it covers every cart/add form
   on every page, whenever it appears.

   HOW IT AVOIDS DOUBLE-ADDING
   Both existing handlers - the <product-form> custom element and ajaxCart's
   formOverride - call preventDefault and are bound closer to the form than
   document is. Submit events bubble, so by the time one reaches this handler
   it is already marked defaultPrevented if anyone owns it, and we stand down.
   =========================================================================== */
(function () {
  'use strict';

  function isCartAddForm(form) {
    if (!form || form.tagName !== 'FORM') { return false; }
    var action = form.getAttribute('action') || '';
    return action.indexOf('/cart/add') !== -1;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;

    if (!isCartAddForm(form)) { return; }

    // Already handled by <product-form> or ajaxCart's formOverride.
    if (e.defaultPrevented) { return; }

    /* No drawer on this page (the cart page excludes the whole drawer bundle),
       so leave the native post alone rather than swallowing it and showing
       the customer nothing. */
    if (!window.ajaxCart || typeof window.ajaxCart.load !== 'function') { return; }

    e.preventDefault();

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok) {
          console.error('Add to cart failed:', (res.data && res.data.description) || res.data);
          return;
        }
        /* Rebuilds the drawer and fires afterCartLoad.ajaxCart, which is what
           theme.liquid listens on to call mono.RightDrawer.open(). */
        try {
          window.ajaxCart.load();
        } catch (err) {
          console.error('Cart drawer refresh failed:', err);
        }
      })
      .catch(function (err) {
        console.error('Add to cart failed:', err);
      });
  }, false);
}());

// hamburger script
// Null-guarded: these elements do not exist on every template, and the
// previous unguarded version threw a TypeError that aborted this whole file.

var menuHamburger = document.querySelector('.menuHamburger');
var sidebarMenu = document.querySelector('.sidebarMenu');
var closeSidebar = document.querySelector('.close');

if (menuHamburger && sidebarMenu) {
  menuHamburger.addEventListener('click', function () {
    sidebarMenu.classList.remove('hide-hamburger');
    menuHamburger.classList.add('hide-hamburger');
  });
}

if (closeSidebar && sidebarMenu && menuHamburger) {
  closeSidebar.addEventListener('click', function () {
    menuHamburger.classList.remove('hide-hamburger');
    sidebarMenu.classList.add('hide-hamburger');
  });
}
